import { AppConfig } from 'AppConfig';

const { domain, apiPath, dataCapturePath } = AppConfig.eventsApi;

const API_URL = `${domain}/${apiPath}`;
const DATA_CAPTURE_URL = `${API_URL}/${dataCapturePath}`;

export { API_URL, DATA_CAPTURE_URL };
